var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getValue } from "firebase/remote-config";
import { isEmpty } from "lodash";
import { getMarketDepth5 } from "../apis/dashboard";
import { set20DepthMessage, setConnected, setGreeksMsg, setSocket, } from "../redux/reducers/openfeed-ws";
import { store } from "../redux/store";
import { checkAndGetDepthToken } from "./methods";
import { SESSION_KEYS, getDataFromSession } from "./session-storage";
// import { connectSolaceClient, solace } from "./solace-wrapper";
import { subscribeToData as subscribeToDataSolace, unsubscribeDataBySubscriber as unsubscribeDataBySubscriberSolace, } from "./solacesocketwrapper";
const { REACT_APP_ENV } = process.env;
let socket;
const noOfRetry = 120000;
let count = 0;
let interval;
let dataUpdateInterval;
let socketUrl = undefined;
let isWindowFocused = true;
let remoteConfig = undefined;
let remoteConfigData = undefined;
let countForHeartBeat = 0;
let manualCloseSocket = true;
export const setRemoteConfigDepth = (newValue) => {
    remoteConfig = newValue;
    refreshAndSetConfigData();
};
const refreshAndSetConfigData = () => {
    if (remoteConfig) {
        const stringValue = getValue(remoteConfig, "derivative_clients_list").asString();
        try {
            remoteConfigData = JSON.parse(stringValue);
        }
        catch (error) {
            console.error(error);
        }
    }
};
const checkAndLogMessage = (method) => {
    let clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    if (!clientCode) {
        clientCode = "";
    }
    if (remoteConfigData &&
        !isEmpty(clientCode) &&
        remoteConfigData.status == "ON") {
        const isClientCodePresent = remoteConfigData.clientlist.find((singleClientCode) => {
            return singleClientCode == clientCode;
            // return singleClientCode == "57675310";
        });
        if (!isEmpty(isClientCodePresent)) {
            //logMessage(getSocketLogMessage(clientCode, method));
        }
    }
};
const subscriberList = [];
const heartBeatSubscriberList = [];
let isSocketConnected = false;
let isSocketInitLoading = false;
const setSocketInitLoading = (newValue) => {
    isSocketInitLoading = newValue;
};
let isDataLoading = false;
const scripMap = {};
export const closeDepthSocket = (manualClose) => {
    if (isSocketConnected && socket) {
        socket.close();
        clearInterval(dataUpdateInterval);
        clearInterval(interval);
        manualCloseSocket = manualClose;
        interval = undefined;
        dataUpdateInterval = undefined;
        isSocketConnected = false;
        socket = undefined;
        closeDepthWebSocket();
    }
};
const setSocketConnected = (newValue) => {
    isSocketConnected = newValue;
    checkAndLogMessage(isSocketConnected ? "Connect" : "Disconnect");
    if (newValue) {
        sendAllMessage(subscriberList);
        if (!dataUpdateInterval) {
            dataUpdateInterval = setInterval(() => {
                checkSyncTimeAndDispatchData();
            }, 500);
        }
    }
    else if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        countForHeartBeat = 0;
    }
};
const checkSyncTimeAndDispatchData = () => {
    // countForHeartBeat++;
    // if (countForHeartBeat == 4) {
    //   countForHeartBeat = 0;
    //   if (isSocketConnected) {
    //     socket?.send("Hi this is a heartbeat message");
    //   }
    // }
    Object.keys(scripMap).forEach((singleScripKey) => {
        const scripObj = scripMap[singleScripKey];
        if (scripObj.data) {
            checkAndDispatchSingleMessageAsPerType(scripObj);
        }
    });
};
export const subscribeToDepthData = (subscriptionMethod, subscriberName, callBackMethod) => {
    if (isSolaceEnabled()) {
        subscribeToDataSolace(subscriptionMethod, subscriberName, callBackMethod);
    }
    else {
        let subsData = subscriberList.find((singleSubData) => {
            if (subscriptionMethod.Method === singleSubData.Method) {
                return singleSubData;
            }
        });
        if (subsData) {
            subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
            // scripMap
            subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
        }
        else {
            subsData = subscriptionMethod;
            subscriberList.push(subscriptionMethod);
        }
        const uniqueRequestArray = [];
        subscriptionMethod.MarketFeedData.forEach((singleElement) => {
            if (callBackMethod) {
                const isNew = addSingleScripSubscriber(subscriberName, singleElement, callBackMethod, subscriptionMethod.Method);
                if (isNew) {
                    // if (
                    //   singleElement.ScripCode == 11536 ||
                    //   singleElement.ScripCode == 532540
                    // ) {
                    //   console.log(isNew, " isNew");
                    // }
                    uniqueRequestArray.push(singleElement);
                }
                else {
                    const scripObj = scripMap[singleElement.Exch +
                        singleElement.ExchType +
                        singleElement.ScripCode];
                    // if (
                    //   singleElement.ScripCode == 11536 ||
                    //   singleElement.ScripCode == 532540
                    // ) {
                    //   console.log(JSON.stringify(scripObj), " scripObj");
                    // }
                    if (scripObj.data) {
                        checkAndDispatchSingleMessageAsPerType(scripObj);
                    }
                }
            }
        });
        if (uniqueRequestArray.length > 0) {
            subscriptionMethod.MarketFeedData = uniqueRequestArray;
        }
        else {
            return;
        }
        if (isWindowFocused) {
            if (isSocketConnected) {
                sendMessage(subscriptionMethod);
            }
            else {
                checkIsSocketConnected(subscriptionMethod.ClientCode);
                getDataFromMarketFeed();
            }
        }
    }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, callBackMethod, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            if (isEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
            // subsObj.callback = callBackMethod;
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                // callback: callBackMethod,
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    // callback: callBackMethod,
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeDepthDataBySubscriber = (subscriberName) => {
    if (isSolaceEnabled()) {
        unsubscribeDataBySubscriberSolace(subscriberName);
    }
    else {
        Object.keys(scripMap).forEach((singleScripKey) => {
            unSubscribeDataByScripKey(subscriberName, singleScripKey);
        });
    }
};
export const unsubscribeDepthDataByScrip = (subsriberName, marketFeedSingleElement) => {
    unSubscribeDataByScripKey(subsriberName, getScripKey(marketFeedSingleElement));
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        const newSubList = scripObj.subscribers.filter((singleElement) => {
            return singleElement.componentName != subscriberName;
        });
        if (newSubList.length > 0) {
            scripObj.subscribers = newSubList;
        }
        else {
            const method1 = {
                Method: "20depth",
                Operation: "Unsubscribe",
                ClientCode: subscriberList[0].ClientCode,
                MarketFeedData: [
                    {
                        Exch: singleScripKey.charAt(0),
                        ExchType: singleScripKey.charAt(1),
                        ScripCode: Number(singleScripKey.substring(2)),
                    },
                ],
            };
            sendMessage(method1);
            delete scripMap[singleScripKey];
        }
    }
};
export const heartBeatDepthData = (subscriptionMethod, subscriberName, callbackMethod) => {
    return subscribeToDepthData(subscriptionMethod, subscriberName, callbackMethod);
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
// const compareAndGetNewObjectsArray = (newSubList: SocketDataType[], currSubList: SocketDataType[]): SocketDataType[] =>{}
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
const sendMessage = (subscriptionMethod) => {
    try {
        // const solaceEnabled = true;
        if (isSocketConnected) {
            const solaceEnabled = getDataFromSession(SESSION_KEYS.SOLACE_ENABLED);
            if (solaceEnabled) {
                subscriptionMethod.MarketFeedData.forEach((singleElement) => {
                    const temp = "prod/marketfeed/20depth/v1/" +
                        singleElement.Exch.toLowerCase() +
                        singleElement.ExchType.toLowerCase() +
                        singleElement.ScripCode;
                    // solace(temp, subscriptionMethod.Operation);
                });
            }
            else {
                const finalJson = {
                    method: subscriptionMethod.Operation,
                    operation: subscriptionMethod.Method,
                    instruments: subscriptionMethod.MarketFeedData.map((singleElement) => {
                        return (singleElement.Exch +
                            singleElement.ExchType +
                            singleElement.ScripCode);
                    }),
                };
                socket === null || socket === void 0 ? void 0 : socket.send(JSON.stringify(finalJson));
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
const sendAllMessage = (localSubscribeList) => {
    localSubscribeList.forEach((singleElement) => {
        sendMessage(singleElement);
    });
};
const updateSocketConnectedStateAndSendData = () => {
    if ((socket === null || socket === void 0 ? void 0 : socket.readyState) == WebSocket.OPEN) {
        setSocketConnected(true);
    }
    else {
        setTimeout(() => {
            updateSocketConnectedStateAndSendData();
        }, 1000);
    }
};
const onSocketOpen = (event) => {
    const ws = event.currentTarget;
    if (ws instanceof WebSocket) {
        store.dispatch(setSocket(ws));
        store.dispatch(setConnected(true));
        updateSocketConnectedStateAndSendData();
    }
    if (interval) {
        clearInterval(interval);
        interval = undefined;
    }
};
const getDataFromMarketFeed = () => __awaiter(void 0, void 0, void 0, function* () {
    // isDataLoading = true;
    if (isDataLoading || isSocketConnected || !isWindowFocused) {
        return;
    }
    // if (isDataLoading) {
    //   return;
    // }
    const marketFeedSubscriber = subscriberList.find((singleData) => {
        if (singleData.Method == "20Depth") {
            return singleData;
        }
    });
    if (!marketFeedSubscriber) {
        return;
    }
    const promises = [];
    const listLength = marketFeedSubscriber.MarketFeedData.length;
    // const loopLength = listLength <= 50 ? 1 : listLength / 50 + 1;
    for (let i = 0; i < listLength; i++) {
        const singleData = marketFeedSubscriber.MarketFeedData[i];
        isDataLoading = true;
        promises.push(getMarketDepth5(singleData.ScripCode, singleData.Exch, singleData.ExchType));
    }
    try {
        const resultArray = yield Promise.all(promises);
        resultArray.forEach((singleCallresult) => {
            //For 20 depth
            // const finalResult = singleCallresult?.data;
            //For 5 depth
            const finalResult = singleCallresult === null || singleCallresult === void 0 ? void 0 : singleCallresult.data.Data;
            if ((finalResult === null || finalResult === void 0 ? void 0 : finalResult.Details) != undefined) {
                handleAndDispatchMessage(finalResult);
            }
        });
    }
    catch (err) {
        console.error(err);
    }
    finally {
        isDataLoading = false;
    }
    setTimeout(() => {
        getDataFromMarketFeed();
    }, 2000);
});
const onSocketMessage = (event) => {
    var _a;
    try {
        let message = ((_a = event.data) === null || _a === void 0 ? void 0 : _a.length) > 1 ? JSON.parse(event === null || event === void 0 ? void 0 : event.data) : {};
        if (Array.isArray(message)) {
            message = message[0];
        }
        handleAndDispatchMessage(message);
    }
    catch (error) {
        console.error(error);
    }
    // try {
    //   const greeksData: any = getGreeksDummyData();
    //   store.dispatch(setGreeksMsg(greeksData)); //set Message here from websocket
    // } catch (error) {
    //   console.error(error);
    // }
    // store.dispatch(setMessage(message));
};
const handleAndDispatchMessage = (message) => {
    if (message && message.PacketIdentifier == "G") {
        store.dispatch(setGreeksMsg(message));
        return;
    }
    if (message && message.Exch) {
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            let dataObj;
            if (scripObj.data) {
                dataObj = scripObj.data;
            }
            else {
                dataObj = {};
                scripObj.data = dataObj;
            }
            let selectedSocketResponseSyncObject;
            if (message.OpenInterest != undefined) {
                if (dataObj.openInterest == undefined) {
                    dataObj.openInterest = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.openInterest.response = message;
                    dataObj.openInterest.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.openInterest;
            }
            else if (message.Details != undefined) {
                if (!dataObj.marketDepthData) {
                    dataObj.marketDepthData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketDepthData.response = message;
                    dataObj.marketDepthData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketDepthData;
            }
            else {
                if (dataObj.marketFeedData == undefined) {
                    dataObj.marketFeedData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketFeedData.response = message;
                    dataObj.marketFeedData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketFeedData;
            }
            if (!selectedSocketResponseSyncObject.syncTime) {
                dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
            }
        }
        else if (isSocketConnected) {
            unsubscribeFromSocket(message.Exch, message.ExchType, message.Token);
        }
    }
};
const checkAndDispatchSingleMessageAsPerType = (scripObj) => {
    var _a, _b, _c;
    if ((_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketDepthData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketDepthData);
    }
    if ((_b = scripObj.data) === null || _b === void 0 ? void 0 : _b.openInterest) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.openInterest);
    }
    if ((_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.marketFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketFeedData);
    }
};
const checkAndDispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject) => {
    if (!selectedSocketResponseSyncObject.syncTime) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
    }
    else if (selectedSocketResponseSyncObject.syncTime ==
        selectedSocketResponseSyncObject.lastUpdateTime) {
        //DO nothing as latest data is already updated
    }
    else {
        // if (
        //   DATA_UI_REFRESHRATE <=
        //   selectedSocketResponseSyncObject.lastUpdateTime.getTime() -
        //     selectedSocketResponseSyncObject.syncTime.getTime()
        // ) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
        // } else {
        //Do nothing as data is already updated within the winow
        // }
    }
};
const dispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject) => {
    selectedSocketResponseSyncObject.syncTime =
        selectedSocketResponseSyncObject.lastUpdateTime;
    store.dispatch(set20DepthMessage(selectedSocketResponseSyncObject.response));
};
const unsubscribeFromSocket = (exch, exchType, scripCode) => {
    if (subscriberList.length > 0) {
        const method1 = {
            Method: "20depth",
            Operation: "UnSubscribe",
            ClientCode: subscriberList[0].ClientCode,
            MarketFeedData: [
                { Exch: exch, ExchType: exchType, ScripCode: scripCode },
            ],
        };
        // const method2 = {
        //   Method: "GetScripInfoForFuture",
        //   Operation: "UnSubscribe",
        //   ClientCode: subscriberList[0].ClientCode,
        //   MarketFeedData: [
        //     { Exch: exch, ExchType: exchType, ScripCode: scripCode },
        //   ],
        // };
        // const method3 = {
        //   Method: "BaseGreeks",
        //   Operation: "UnSubscribe",
        //   ClientCode: subscriberList[0].ClientCode,
        //   MarketFeedData: [
        //     { Exch: exch, ExchType: exchType, ScripCode: scripCode },
        //   ],
        // };
        sendMessage(method1);
        //sendMessage(method2);
        //sendMessage(method3);
    }
};
export const unSubscribeAllDepthData = () => {
    const cloneData = JSON.parse(JSON.stringify(subscriberList));
    cloneData.forEach((singleSubscription) => {
        singleSubscription.Operation = "UnSubscribe";
    });
    sendAllMessage(cloneData);
};
const onSocketError = (event) => {
    console.error("error event");
    console.error(event);
    handleClose();
};
const onSocketClose = (event) => {
    // console.log("close event");
    // console.log(event);
    handleClose();
};
function handleClose() {
    setSocketConnected(false);
    socket = undefined;
    store.dispatch(setConnected(false));
    store.dispatch(setSocket(null));
    if (isWindowFocused) {
        getDataFromMarketFeed();
    }
    if (interval && !manualCloseSocket) {
        return;
    }
    interval = setInterval(() => {
        if (count >= noOfRetry) {
            if (interval)
                clearInterval(interval);
            interval = undefined;
            // console.error("No of retry for connection exceeds");
            return;
        }
        if (isWindowFocused) {
            reSubscribeDepthSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
        }
        else {
            if (interval)
                clearInterval(interval);
        }
        count = count + 1;
    }, 5000);
}
export const closeDepthWebSocket = () => {
    isWindowFocused = false;
    if (isSocketConnected && socket) {
        socket.close();
    }
};
export const checkIsSocketConnected = (localClientCode) => {
    try {
        if (!socket && !isSocketConnected) {
            reSubscribeDepthSocket(localClientCode);
        }
    }
    catch (error) {
        console.error(error);
    }
};
export const reSubscribeDepthSocket = (localClientCode) => {
    try {
        if (socket || isSolaceEnabled()) {
            if (isSocketConnected) {
                if (!dataUpdateInterval) {
                    dataUpdateInterval = setInterval(() => {
                        checkSyncTimeAndDispatchData();
                    }, 500);
                }
                sendAllMessage(subscriberList);
            }
            else if (isSocketInitLoading) {
                //Do nothing as socket init is already called
            }
            else if (isSolaceEnabled()) {
                // connectSolaceClient(setSocketConnected, setSocketInitLoading);
            }
            else {
                //Socket is trying to connect and will get connected and get subscribed anyway
            }
            // socket.close();̦
        }
        else if (isSocketInitLoading) {
            //Do nothing as socket init is already called
        }
        else if (socketUrl) {
            initDepthWebSocket(socketUrl, true);
        }
        else {
            depthSocketInit(localClientCode, true);
        }
    }
    catch (error) {
        console.error(error);
    }
};
export const initDepthWebSocket = (wsUrl, localIsWindowFocus) => {
    if (localIsWindowFocus) {
        isWindowFocused = true;
    }
    setSocketInitLoading(true);
    socketUrl = wsUrl;
    return new Promise((resolve, reject) => {
        try {
            if (!wsUrl || !isWindowFocused || isSocketConnected) {
                return;
            }
            socketUrl = wsUrl;
            socket = new WebSocket(wsUrl);
            socket.onopen = onSocketOpen;
            socket.onmessage = onSocketMessage;
            socket.onerror = onSocketError;
            socket.onclose = onSocketClose;
            resolve(socket);
        }
        catch (err) {
            reject(err);
        }
        finally {
            setSocketInitLoading(false);
        }
    });
};
export const depthSocketInit = (localClientCode, localIsWindowFocus) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let accessToken = yield checkAndGetDepthToken();
        // if (accessToken == undefined) {
        //   const currentTimeStamp = new Date().toString();
        //   console.log(currentTimeStamp);
        //   const response = await getMarketDepthToken();
        //   const depthResponse = response.data;
        //   depthResponse.timeStamp = currentTimeStamp;
        //   accessToken = depthResponse.access_token;
        // }
        if (accessToken) {
            if (REACT_APP_ENV == "development")
                accessToken =
                    "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ii1FY0U2TlE0MFJtaUJRQUt6Zm4wYnFheXhZY2JXOXdaaURmZ28wQm52a3cifQ.eyJqdGkiOiJ2V3BNcTVyd35mMzJSMFN1Q2Zta18iLCJpc3MiOiJodHRwczovL2lpZmwub25lbG9naW4uY29tL29pZGMvMiIsImlhdCI6MTY5NzYyOTM1MiwiZXhwIjoxNjk3NjcyNTUyLCJhdWQiOiI4MDE1ZTg4MC1mOWEzLTAxMzgtMmE0NC0wMjVmNDVmNTc5OTgzODE4OCJ9.YJCZCEZcstf80_Q-xOnne7LUAK8zlVs8MSUKg5iOfSH9rFhM5hszg9MxuOdv70meKaazjZe_aQiGn1ksAZ24t1LToH2BmBDwAKwM-h_lF5k_QbjTtlQh_xAW528vkyz_uub2RvAPy5UatxJIwvr7kNmv73DXeIRlM3naQ6q47mqvuCrUAv02k2ILytHCF-iC6SLLvYqh2M9zZ--kRt8xqT_AB_m222cZ9ss9jDSfBY7Kl_azieLnzZzCqiTcIYgCMRIkFDYo1bNhuJO51z2jNsDtGytB1jfnopih9snIP3ZqmEaJgGqmyfOv6U9hn0Lt48uEyKmIxEfRY-05hCCwmw";
            // const swarajWsurl = `wss://marketdepth-socket.5paisa.com/ws?access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ii1FY0U2TlE0MFJtaUJRQUt6Zm4wYnFheXhZY2JXOXdaaURmZ28wQm52a3cifQ.eyJqdGkiOiJfaE9kRDBDZXVvYVozRzZVXzNiS0wiLCJpc3MiOiJodHRwczovL2lpZmwub25lbG9naW4uY29tL29pZGMvMiIsImlhdCI6MTY3MjAzNTY2OCwiZXhwIjoxNjcyMDc4ODY4LCJhdWQiOiI4MDE1ZTg4MC1mOWEzLTAxMzgtMmE0NC0wMjVmNDVmNTc5OTgzODE4OCJ9.Bp_4CnE6EfdcS0VLW8rJd3pg4Rv1R7Okx2JxVGKnXhbmem9DMkJI51vdN4Xwtkp9G1f-fzDiiTme6W_V8sfemDiW37MAB319xygjQAIWAGCiQqAWiAQ75Ec2zP3iZVC4PjcYJ3JVXKKWPOd679WvaanzmTSPz_9FufGuTOw-yGB2bCASc2ryCFQaGUxsQ_S67QNQiUlP-0y3Ig9B38dbPPtZ-anLpoTINIDQ4ubu1H26ZjXajC0wSqJiVk8HEBtYwZmInssRybRcgq1bNki7Cv_3GVg2clqlhFyjALgpGC58IeSsMYc6ytRkklFSw-5ONkG18FAv19-Rt2YmiLHCwQ`;
            // const swarajWsurl = `wss://marketfeed-centralindia-20depthws-app.azurewebsites.net/ws?access_token=${accessToken}`;
            const swarajWsurl = `wss://marketdepth-socket.5paisa.com/ws?access_token=${accessToken}`;
            initDepthWebSocket(swarajWsurl, localIsWindowFocus);
        }
        // }
    }
    catch (err) {
        console.error(err);
    }
    finally {
    }
});
const randomMessageGenerator = (isEven) => {
    let seconds = new Date().getSeconds();
    //This is done so ticker size is 5 paisa only
    if (seconds > 5) {
        seconds = seconds - (seconds % 5);
    }
    else {
        seconds = 0;
    }
    Object.keys(scripMap).forEach((singleKey) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const scripObj = scripMap[singleKey];
        if (scripObj && scripObj.subscribers.length > 0) {
            if ((_b = (_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketFeedData) === null || _b === void 0 ? void 0 : _b.response) {
                const dataToSend = Object.assign({}, (_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.marketFeedData.response);
                // dataToSend.PClose = dataToSend.PClose;
                dataToSend.LastRate = dataToSend.LastRate + seconds / 100;
                store.dispatch(set20DepthMessage(dataToSend));
            }
            else if ((_e = (_d = scripObj.data) === null || _d === void 0 ? void 0 : _d.openInterest) === null || _e === void 0 ? void 0 : _e.response) {
                const dataToSend = Object.assign({}, (_f = scripObj.data) === null || _f === void 0 ? void 0 : _f.openInterest.response);
                dataToSend.LastRate = dataToSend.OpenInterest + seconds * 100000;
                store.dispatch(set20DepthMessage(dataToSend));
            }
            else if ((_h = (_g = scripObj.data) === null || _g === void 0 ? void 0 : _g.marketDepthData) === null || _h === void 0 ? void 0 : _h.response) {
                const dataToSend = Object.assign({}, (_j = scripObj.data) === null || _j === void 0 ? void 0 : _j.marketDepthData.response);
                if (dataToSend.Details.length == 0) {
                    dataToSend.Details.push({
                        Quantity: 999,
                        Price: 123,
                        NumberOfOrders: 100,
                        BbBuySellFlag: 66,
                    });
                }
                dataToSend.Details[0].Price =
                    dataToSend.Details[0].Price + seconds / 100;
                dataToSend.Details[0].Quantity =
                    dataToSend.Details[0].Quantity + seconds;
                dataToSend.Details[0].NumberOfOrders =
                    dataToSend.Details[0].NumberOfOrders + seconds;
                store.dispatch(set20DepthMessage(dataToSend));
            }
        }
    });
    setTimeout(() => {
        randomMessageGenerator(isEven);
    }, 1000);
};
const isSolaceEnabled = () => getDataFromSession(SESSION_KEYS.SOLACE_ENABLED);
